export enum CachePolicy {
  None,
  Persistent,
  Session,
  Service
}
